var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.srcdoc)?_c('iframe',{key:_vm.iframeKey,staticClass:"html-content-iframe",attrs:{"srcdoc":_vm.srcdoc},on:{"load":_vm.onIframeLoaded}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }